<template>
  <div class="training-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.trainings.title') }}</h1>
        <p>{{ $t('bo.trainings.subtitle') }}</p>
      </div>
      <button type="button" class="btn-primary" @click="showCreate = true">
        {{ $t('bo.trainings.newTraining') }}
      </button>
    </div>

    <AdminTrainingList
      ref="listRef"
      @edit="handleEdit"
      @archive="handleArchive"
    />

    <CreateAdminTrainingModal
      v-if="showCreate"
      @close="showCreate = false"
      @created="handleCreated"
    />

    <EditAdminTrainingModal
      v-if="editingTraining"
      :training="editingTraining"
      @close="editingTraining = null"
      @updated="handleUpdated"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import AdminTrainingList from './AdminTrainingList.vue'
import CreateAdminTrainingModal from './CreateAdminTrainingModal.vue'
import EditAdminTrainingModal from './EditAdminTrainingModal.vue'
import trainingAdminService from '@/services/trainingAdminService'

const { t } = useI18n()

const showCreate = ref(false)
const editingTraining = ref(null)
const listRef = ref(null)

const handleEdit = (training) => {
  editingTraining.value = training
}

const handleArchive = async (id) => {
  if (!confirm(t('bo.trainings.confirmArchive'))) return
  try {
    await trainingAdminService.archive(id)
    listRef.value?.loadTrainings()
  } catch (e) {
    alert(e.response?.data?.message || t('bo.trainings.failedArchive'))
  }
}

const handleCreated = () => {
  showCreate.value = false
  listRef.value?.loadTrainings()
}

const handleUpdated = () => {
  editingTraining.value = null
  listRef.value?.loadTrainings()
}
</script>

<style scoped>
.training-manager {
  padding: 2rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
}

.page-header p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.btn-primary {
  padding: 0.5rem 1.25rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
}

.btn-primary:hover {
  background: #2563eb;
}
</style>
